export const border = {
  border: {
    radius: {
      sm: '3px',
      xl: '16px',
    },
  },
};
